export default __webpack_public_path__ + "static/media/Calendar.e23046b8.mov";